import * as querystring from 'query-string';

const JSONTryParseOtherwiseString = (str: string) => {
  try {
    return JSON.parse(str);
  } catch (error) {
    return str;
  }
};

type Resolver = (key: string) => { value?: any; success: boolean };

type Writer = (key: string, value: any) => void;

export enum StorageKind {
  Local = 1 << 0,
  Session = 1 << 1,
}

const querystringResolver: Resolver = key => {
  if (location) {
    const query = querystring.parse(location.search);
    const value = JSONTryParseOtherwiseString(query[key] as string); // TODO Fix it

    if (value) {
      return { success: true, value };
    }
  }

  return { success: false };
};

const sessionStorageResolver: Resolver = key => {
  if (sessionStorage) {
    const valueString = sessionStorage.getItem(key);

    if (valueString === '') {
      return { success: true, value: valueString };
    }

    const value = valueString
      ? JSONTryParseOtherwiseString(valueString)
      : undefined;

    if (value != null) {
      return { success: true, value };
    }
  }

  return { success: false };
};

const localStorageResolver: Resolver = key => {
  if (localStorage) {
    const valueString = localStorage.getItem(key);

    if (valueString === '') {
      return { success: true, value: valueString };
    }

    const value = valueString
      ? JSONTryParseOtherwiseString(valueString)
      : undefined;

    if (value != null) {
      return { success: true, value };
    }
  }

  return { success: false };
};

export const writeToLocalStorage: Writer = (key, value) => {
  if (value == null) {
    localStorage.removeItem(key);
  }

  localStorage.setItem(key, JSON.stringify(value));
};

export const writeToSessionStorage: Writer = (key, value) => {
  if (value == null) {
    sessionStorage.removeItem(key);
  }

  sessionStorage.setItem(key, JSON.stringify(value));
};

export const writeToStorage = (
  key,
  value,
  storage: StorageKind = StorageKind.Local | StorageKind.Session,
) => {
  if (storage & StorageKind.Local) writeToLocalStorage(key, value);
  if (storage & StorageKind.Session) writeToSessionStorage(key, value);
};

export const getSettingByKey = (key: string) => {
  let result = querystringResolver(key);

  if (result.success) {
    return result.value;
  }

  result = sessionStorageResolver(key);

  if (result.success) {
    return result.value;
  }

  result = localStorageResolver(key);

  if (result.success) {
    return result.value;
  }

  return undefined;
};
